export default __webpack_public_path__ + "static/media/a.6bc1a630.pdf";